import "@/App.css";
import React, { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import Nav from "@/components/site/Nav";
import Landing from "@/pages/Landing";
import FamilyTreesPage from "@/pages/FamilyTrees";
import CelebrateALifePage from "@/pages/CelebrateALife";
import FamousFamiliesPage from "@/pages/FamousFamilies";
import FamilyDetailPage from "@/pages/FamilyDetail";
import IndianHeritagePage from "@/pages/IndianHeritage";
import HeritageTopicPage from "@/pages/HeritageTopic";
import ExploreIndiaPage from "@/pages/ExploreIndia";
import AboutPage from "@/pages/About";
import ContactPage from "@/pages/Contact";
import MyTreePage from "@/pages/MyTree";
import MyPortraitsPage from "@/pages/MyPortraits";
import CardStudioPage from "@/pages/CardStudio";
import MyCardsPage from "@/pages/MyCards";
import CardsFeedPage from "@/pages/CardsFeed";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

function LenisRoot() {
  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    const id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
    };
  }, []);
  return null;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <LenisRoot />
        <ScrollToTop />
        <Nav />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/family-trees" element={<FamilyTreesPage />} />
          <Route path="/my-tree" element={<MyTreePage />} />
          <Route path="/my-portraits" element={<MyPortraitsPage />} />
          <Route path="/cards" element={<CardStudioPage />} />
          <Route path="/my-cards" element={<MyCardsPage />} />
          <Route path="/celebrate/:occasion" element={<CardsFeedPage />} />
          <Route path="/celebrate-a-life" element={<CelebrateALifePage />} />
          <Route path="/famous-families" element={<FamousFamiliesPage />} />
          <Route path="/famous-families/:id" element={<FamilyDetailPage />} />
          <Route path="/indian-heritage" element={<IndianHeritagePage />} />
          <Route path="/indian-heritage/:slug" element={<HeritageTopicPage />} />
          <Route path="/explore-india" element={<ExploreIndiaPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<Landing />} />
        </Routes>
        <Toaster position="bottom-center" richColors closeButton theme="light" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
